import {
  isPlainObject,
  isRichTextDocument,
  PlainObject,
} from '../helpers/helpers';

const isEmptyObject = (value: unknown): boolean =>
  isPlainObject(value) && Object.keys(value).length === 0;

export const removeEmptyObjects = (value: unknown): unknown => {
  if (Array.isArray(value)) return value.map(removeEmptyObjects);

  if (!isPlainObject(value) || isRichTextDocument(value)) return value;

  const cleaned: PlainObject = {};

  Object.entries(value).forEach(([fieldName, fieldValue]) => {
    cleaned[fieldName] = isEmptyObject(fieldValue)
      ? undefined
      : removeEmptyObjects(fieldValue);
  });

  return cleaned;
};
